module.exports = __webpack_public_path__ + "static/Simon Fan.82643d03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Simon Fan.jpg
// module id = 1236
// module chunks = 6166952557895